import { z } from 'zod'

const MESSAGE_ADRESSE_INVALIDE = 'Adresse invalide'

// z.string().url() valide selon la norme WHATWG, qui accepte n'importe quel
// schéma syntaxiquement correct — y compris `javascript:` et `data:`. Un lien
// social, une adresse cartographique ou une adresse Planity acceptant l'un de
// ces schémas serait rendue telle quelle dans un <a href> du site public
// (React ne les filtre pas) : une injection de script stockée, exploitable
// par quiconque a un accès en écriture à l'administration. On valide donc
// nous-mêmes via l'API URL du navigateur/Node, en n'acceptant que http/https.
function estUneAdresseHttp(value: string): boolean {
  try {
    return ['http:', 'https:'].includes(new URL(value).protocol)
  } catch {
    return false
  }
}

// Schéma partagé pour tout champ d'URL destiné à être utilisé comme lien sur
// le site public (attribut href ou équivalent). À utiliser à la place de
// `z.string().url()` pour un tel champ — ne pas revenir à `.url()` seul, qui
// réintroduirait la faille ci-dessus. Un futur champ d'URL (prochain
// chantier) doit repartir de celui-ci plutôt que d'en écrire un nouveau.
export const httpUrlSchema = z.string().refine(estUneAdresseHttp, MESSAGE_ADRESSE_INVALIDE)
